import previewsSagas from './previews/sagas';

export default [...previewsSagas];
